import Request, { RequestParams, RequestPageParams } from './request'
import { getSingletonStore } from 'common/utils'
import { DIOX } from './index'
// import getTxService from '@/api/transactions'

class AddressService extends Request {
  constructor(props: RequestParams) {
    super(props)
  }

  getAddressMetadata(address: string) {
    return this.get<{ State: { Metadata: DIOX.MetaData } }>('', {
      params: { module: 'address', action: 'baseinfo', address },
    })
  }

  getAddressDetail(address: string) {
    return this.get<DIOX.TokenAddress | DIOX.NFTAddress | DIOX.DAppAddress | DIOX.BaseAddress>('', {
      params: { module: 'address', action: 'detail', address },
    })
  }

  getAddressTokens(address: string, query?: RequestPageParams) {
    return this.get<DIOX.TokenResponse>('', {
      params: { module: 'address', action: 'tokens', address, limit: query?.limit || 20, pos: query?.pos || 0 },
    })
  }

  getMyTokenList(initiator: string) {
    return this.get<DIOX.MyTokenRespone[]>('', {
      params: {
        module: 'address',
        action: 'initiatortokens',
        initiator,
        function: 'core.delegation.address.create_token',
      },
    })
  }

  getAddressDAppsList(address: string, query?: RequestPageParams) {
    return this.get<DIOX.DAppResponse>('', {
      params: {
        module: 'address',
        action: 'dapps',
        address,
        limit: query?.limit || 20,
        pos: query?.pos || 0,
      },
    })
  }

  getAddressBalance(address: string) {
    return this.get<DIOX.AddressBalance>('', { params: { module: 'address', action: 'balance', address } })
  }
}

export default getSingletonStore<AddressService>(AddressService, { baseURL: '/api' })
